module.exports = __webpack_public_path__ + "fdb652dcc200dd23b8b8040176858c36.woff2";